import { BookKeyBundle } from "../../entities/encryption/bookKeyBundle";
import { getAuthorRefForGateway, getAuthorRefFromGateway } from './ParsingUtils';
export default class BookKeyBundleParser {
    static toGateway(bookKeyBundle, app) {
        return {
            Id: bookKeyBundle._id,
            Author: getAuthorRefForGateway(bookKeyBundle.author, app),
            Book: bookKeyBundle.book._id,
            StartTime: bookKeyBundle.startTime,
            EndTime: bookKeyBundle.endTime,
            Users: bookKeyBundle.keys.map((key) => ({
                Id: key.user._id,
                Key: key.keyId,
                Passphrase: key.passphrase,
            })),
        };
    }
    static fromGateway(gatewayBookKeyBundle, app) {
        const bookKeyBundle = new BookKeyBundle({
            author: getAuthorRefFromGateway(gatewayBookKeyBundle.Author, app),
            book: { _id: gatewayBookKeyBundle.Book },
            startTime: gatewayBookKeyBundle.StartTime,
            endTime: gatewayBookKeyBundle.EndTime,
            keys: gatewayBookKeyBundle.Users.map((gatewayUser) => ({
                keyId: gatewayUser.Key,
                passphrase: gatewayUser.Passphrase,
                user: { _id: gatewayUser.Id },
            })),
        });
        Object.assign(bookKeyBundle, {
            _id: gatewayBookKeyBundle.Id,
        });
        return bookKeyBundle;
    }
}
//# sourceMappingURL=BookKeyBundleParser.js.map